import { getLogger } from '../../diagnostics/logger';
import moment from 'moment';
import { Action, ActionMeta } from '../../actions';
import {
  LOAD_NETWORK_TARIFFS_FAILURE,
  LOAD_NETWORK_TARIFFS_PENDING,
  LOAD_NETWORK_TARIFFS_SUCCESS,
} from '../../actions/actionTypes';
import { TariffFilter } from '../../api/tariffApi';
import { TariffDropdownItem } from '../../components/ui/input/DropdownInput';
import { SimManagementError } from '../../models/Errors';
import { initialAppState } from '../../models/state/appState';
import { TariffsStateCacheTimeout } from '../../models/state/simProvision/cacheTimeouts';
import { getDefaultTariffDropdownItems } from '../../models/state/simProvision/defaults';
import {
  getAccountNetworkKey,
  TariffDropdownItems,
  TariffDropdownItemsState,
} from '../../models/state/simProvision/simProvisionState';

const log = getLogger('simManagement.reducers.tariffReducer');

export default function tariffReducer(
  state: TariffDropdownItemsState = initialAppState.simProvisionState.tariffs,
  action: any,
): TariffDropdownItemsState {
  switch (action.type) {
    case LOAD_NETWORK_TARIFFS_PENDING: {
      const typedAction = action as Action<TariffFilter>;
      const { payload } = typedAction;
      if (!payload) {
        log.warn('No payload');
        return state;
      }

      const { accountId, networkId } = payload;
      const networkTariffs: TariffDropdownItems = {
        ...getDefaultTariffDropdownItems(),
        isLoading: true,
      };

      const accountNetworkKey = getAccountNetworkKey(accountId, networkId);
      const changedState: TariffDropdownItemsState = {};
      changedState[accountNetworkKey] = networkTariffs;

      const newState = Object.assign({}, state, changedState);
      return newState;
    }
    case LOAD_NETWORK_TARIFFS_FAILURE: {
      const typedAction = action as ActionMeta<TariffFilter, SimManagementError>;
      const { meta, payload } = typedAction;
      if (!payload) {
        log.warn('No payload');
        return state;
      }

      if (!meta) {
        log.warn('No meta');
        return state;
      }

      const { accountId, networkId } = payload;
      const networkTariffs: TariffDropdownItems = {
        ...getDefaultTariffDropdownItems(),
        error: meta,
      };

      const accountNetworkKey = getAccountNetworkKey(accountId, networkId);
      const changedState: TariffDropdownItemsState = {};
      changedState[accountNetworkKey] = networkTariffs;

      const newState = Object.assign({}, state, changedState);
      return newState;
    }
    case LOAD_NETWORK_TARIFFS_SUCCESS: {
      const typedAction = action as ActionMeta<TariffFilter, TariffDropdownItem[]>;
      const { meta, payload } = typedAction;
      if (!payload) {
        log.warn('No payload');
        return state;
      }

      if (!meta) {
        log.warn('No meta');
        return state;
      }

      const { accountId, networkId } = payload;
      const tariffs = meta;
      const date = new Date();

      const networkTariffs: TariffDropdownItems = {
        ...getDefaultTariffDropdownItems(),
        items: [...tariffs],
        byId: Object.assign({}, ...tariffs.map((a: any) => ({
          [a.key]: a
        }))),
        expiresOn: moment().add(TariffsStateCacheTimeout, 'seconds').toDate(),
      };

      const accountNetworkKey = getAccountNetworkKey(accountId, networkId);
      const changedState: TariffDropdownItemsState = {};
      changedState[accountNetworkKey] = networkTariffs;

      const newState = Object.assign({}, state, changedState);
      return newState;
    }
    default:
      return state;
  }
}
